module.exports = __webpack_public_path__ + "static/media/LogoMakr_3Klh9R.6d004151.png";